import Cookies from 'js-cookie'

const TokenKey = 'vue_shop_user_token'

// const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL3V3aWdiLm15bmF0YXBwLmNjIiwiaWF0IjoxNjcxNjkxODIwLCJuYmYiOjE2NzE2OTE4MjAsImV4cCI6MTY3MjI5NjYyMCwiZGF0YSI6eyJ1c2VyIjp7ImlkIjoiNTYifX19.w_pEVyrJtAOZi3rmbnUdGNni-4A_nhB4eWpqKGzE-Dk';
// Cookies.set(TokenKey, token);

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}


// WEBPACK FOOTER //
// ./src/assets/js/auth.js